import { TextField } from "@mui/material";
import AutoCompleteTextField from "components/common/AutoCompleteTextField";

export const FreeFormCarrierInput = ({ value, onChangeValue, autoFocus }) => (
  <TextField
    value={value ?? ""}
    fullWidth
    onChange={(e) => onChangeValue(e.target.value)}
    variant={"filled"}
    autoComplete={"off"}
    size={"small"}
    hiddenLabel
    autoFocus={autoFocus}
  />
);

export const AutocompleteCarrierInput = ({
  value,
  onChangeValue,
  autoFocus,
}) => (
  <AutoCompleteTextField
    category={"carriers"}
    value={value ?? ""}
    fullWidth
    onChange={(e) => onChangeValue(e.target.value)}
    onChangeValue={onChangeValue}
    variant={"filled"}
    autoComplete={"off"}
    size={"small"}
    hiddenLabel
    autoFocus={autoFocus}
  />
);
